import React from 'react';
import _ from 'lodash';

import BaseModal from 'src/components/Modal/BaseModal';
import { EVENT_ATTRIBUTES_BY_EVENT_TYPE } from 'src/constants/constants';
import { HandlerComponentProps } from 'src/constants/types';

const TriggeredAutomationModal = ({
  onSuccess,
  onDismiss,
  onClose,
  engagementId,
  task,
}: HandlerComponentProps) => {
  // const {
  //   result: triggeredAction,
  //   isLoading,
  // }: {
  //   result: TriggeredActionDetail,
  //   isLoading: boolean,
  // } = useGetRequest({
  //   url: `/automatic/engagements/${engagementId}/triggered-effects/${task.triggeredActionId}/`
  // });

  // if (isLoading) return null;

  const {
    triggeredActionHandler: Component,
    // @ts-ignore - action will not be undefined
  } = EVENT_ATTRIBUTES_BY_EVENT_TYPE[task.triggeredAction.action.type];

  return (
    <BaseModal
      onClose={onClose}
      title={_.upperFirst(task.title)}
      maxWidth="sm"
    >
      <Component
        onClose={onClose}
        onSuccess={onSuccess}
        onDismiss={onDismiss}
        engagementId={engagementId}
        task={task}
        triggeredAction={task.triggeredAction}
      />
    </BaseModal>
  );
};

export default TriggeredAutomationModal;
